import { useEffect, useState } from "react";

const API = "https://growthloomdigital.com/api";

const AdminBlogForm = ({ setActive, editBlog }) => {

  const [title, setTitle] = useState("");
  const [subheading, setSubheading] = useState("");
  const [content, setContent] = useState("");
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);

  const [preview1, setPreview1] = useState(null);
  const [preview2, setPreview2] = useState(null);

  // ✅ New states
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // fill data for edit
  useEffect(() => {
    if (editBlog) {
      setTitle(editBlog.title);
      setSubheading(editBlog.subheading);
      setContent(editBlog.content);
    }
  }, [editBlog]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("subheading", subheading);
      formData.append("content", content);

      if (image1) formData.append("image1", image1);
      if (image2) formData.append("image2", image2);

      let res;

      if (editBlog) {
        formData.append("id", editBlog.id);

        res = await fetch(`${API}/update.php`, {
          method: "POST",
          body: formData,
        });
      } else {
        res = await fetch(`${API}/create.php`, {
          method: "POST",
          body: formData,
        });
      }

      // ✅ handle any response safely
      let data;
      try {
        data = await res.json();
      } catch {
        data = {};
      }

      console.log("API Response:", data);

      // ✅ MAIN FIX: use res.ok instead of data.success
      if (res.ok) {
        setMessage(
          editBlog
            ? "Blog updated successfully!"
            : "Blog published successfully!"
        );

        // reset form
        setTitle("");
        setSubheading("");
        setContent("");
        setImage1(null);
        setImage2(null);
        setPreview1(null);
        setPreview2(null);

        setTimeout(() => {
          setActive("blogs");
        }, 1500);
      } else {
        setError(data.message || "Failed to save blog");
      }

    } catch (err) {
      console.error(err);
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);
  //   setMessage("");
  //   setError("");

  //   try {
  //     const formData = new FormData();
  //     formData.append("title", title);
  //     formData.append("subheading", subheading);
  //     formData.append("content", content);

  //     if (image1) formData.append("image1", image1);
  //     if (image2) formData.append("image2", image2);

  //     let res;

  //     if (editBlog) {
  //       formData.append("id", editBlog.id);

  //       res = await fetch(`${API}/update.php`, {
  //         method: "POST",
  //         body: formData,
  //       });
  //     } else {
  //       res = await fetch(`${API}/create.php`, {
  //         method: "POST",
  //         body: formData,
  //       });
  //     }

  //     const data = await res.json();

  //     if (data.success) {
  //       setMessage(
  //         editBlog
  //           ? "Blog updated successfully!"
  //           : "Blog published successfully!"
  //       );

  //       // optional reset form
  //       setTitle("");
  //       setSubheading("");
  //       setContent("");
  //       setImage1(null);
  //       setImage2(null);
  //       setPreview1(null);
  //       setPreview2(null);

  //       // redirect after short delay
  //       setTimeout(() => {
  //         setActive("blogs");
  //       }, 1500);
  //     } else {
  //       setError(data.message || "Something went wrong");
  //     }
  //   } catch (err) {
  //     setError("Server error. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-3xl">

      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Title */}
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Blog Title"
          className="w-full border p-2 rounded"
          required
        />

        {/* Subheading */}
        <input
          value={subheading}
          onChange={(e) => setSubheading(e.target.value)}
          placeholder="Subheading"
          className="w-full border p-2 rounded"
          required
        />

        {/* Content */}
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Blog Content"
          rows="6"
          className="w-full border p-2 rounded"
          required
        />

        {/* Image 1 */}
        <input
          type="file"
          onChange={(e) => {
            const file = e.target.files[0];
            setImage1(file);
            if (file) setPreview1(URL.createObjectURL(file));
          }}
        />
        {preview1 && <img src={preview1} className="w-40 rounded" />}

        {/* Image 2 */}
        <input
          type="file"
          onChange={(e) => {
            const file = e.target.files[0];
            setImage2(file);
            if (file) setPreview2(URL.createObjectURL(file));
          }}
        />
        {preview2 && <img src={preview2} className="w-40 rounded" />}

        {/* Messages */}
        {message && <p className="text-green-600">{message}</p>}
        {error && <p className="text-red-600">{error}</p>}

        {/* Submit Button */}
        <button
          disabled={loading}
          className={`px-4 py-2 rounded text-white flex items-center justify-center ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600"
            }`}
        >
          {loading ? (
            <span className="animate-pulse">⏳ Processing...</span>
          ) : editBlog ? (
            "Update Blog"
          ) : (
            "Publish Blog"
          )}
        </button>

      </form>
    </div>
  );
};

export default AdminBlogForm;